<template>
  <div>
    <FITModal ref="confirmCommissionModal" reference="modal" :title="$t('adm.companyCommission.header')" @click="onClickModal">
      <div slot="body">
        <h4 class="pb-3">{{$t('adm.companyCommission.payCommissionModal.content')}}</h4>
        <FITDatePicker :label="$t('adm.companyCommission.payCommissionModal.commissionDate')" v-model="payCommForm.commissionDate" :width="8"></FITDatePicker>
        <FITTextInput :label="$t('adm.companyCommission.payCommissionModal.commissionReceived')" v-model="payCommForm.commissionActualReceived" :width="8"></FITTextInput>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('adm.companyCommission.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right" v-if="isReport">
            <b-btn @click="exportReport" variant="success"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable @onRowSelected="onRowSelected" ref="searchTable" keywordPlaceholder="Type to Search" searchAction="getCompanyCommRecord" vuexModule="Adm" type="policyCommission" :filters="filters" :columns="columns" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard, FITModal, FITAlert, FITTextInput, FITDatePicker } from '@/components'
import Vue from 'vue'
import { domain } from '@/api/api.js'
import { saveAs } from 'file-saver/FileSaver';
import { mapGetters } from 'vuex'
export default {
  name: 'CompanyCommissionRecord',
  components: {
    FITSearchableTable,
    FITFormCard,
    FITModal,
    FITAlert,
    FITTextInput,
    FITDatePicker
  },
  props: {
    isReport: {
      type: Boolean,
      default: false
    }
  },
  created() {
    var columns = []
    if (this.isReport) {
      columns = this.defaultColumns.concat(this.reportColumns);
    } else {
      columns = this.defaultColumns.concat(this.adminColumns);
    }
    Vue.set(this, 'columns', columns);
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportCompanyCommissionReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);
      })
    },
    generateCommStatusDom(status, translatedStatus) {
      let icon = '';
      let text = 'danger';
      switch (status.toLowerCase()) {
        case 'p':
          icon = 'fa-check'
          text = 'success'
          break;
        case 'u':
          icon = 'fa-times-circle'
          text = 'danger'
          break;
      }
      return `<span class="text-${text}"><i class="fa ${icon} mr-2"></i>${translatedStatus}</span>`;
    },
    onClickModal(evt) {
      if (!evt) {
        return;
      }
      let params = {
        ID: this.seletedRow.ID,
        ...this.payCommForm,
      }
      this.$store.dispatch('Adm/payCompanyCommission', params).then((json) => {
        this.$refs.searchTable.search();
        this.$refs.alert.showAlert()
        Vue.set(this, 'payCommForm', {
          commissionDate: '',
          commissionActualReceived: ''
        });
        this.$refs.confirmCommissionModal.closeModal();
        this.$store.commit('Crm/setNotificationOnChangeState', { state: true });

      }).catch((err) => {
        console.error(err);
      })
    },
    onRowSelected(row) {
      if (this.isReport) {
        return;
      }
      Vue.set(this, 'seletedRow', row);
      this.$refs.confirmCommissionModal.openModal();
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Adm', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    setCurrentFilters(val) {
      Vue.set(this, 'currentFilters', val);
      console.debug(val);
    },
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  data() {
    return {
      alertParams: {
        content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`,
        variant: 'success'
      },
      seletedRow: {},
      payCommForm: {
        commissionDate: '',
        commissionActualReceived: ''
      },
      currentFilters: {},
      filters: [{
          label: this.$t('dw.general.policyType'),
          key: 'policyType',
          type: 'select',
          default: 'P',
          haveAll: false,
        },
        {
          label: this.$t('dw.general.status'),
          key: 'status',
          type: 'select',
          default: null
        },
        {
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],
      columns: [],
      defaultColumns: [{
          key: 'policyNumber',
          label: this.$t('adm.companyCommission.policyNumber'),
          thClass: ['tableMinWidth120'],
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'policyReference',
          label: this.$t('adm.companyCommission.policyReference'),
          thClass: ['tableMinWidth120'],
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'policyType',
          label: this.$t('dw.report.sale.policyType'),
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        // {
        //   key: 'productCode',
        //   label: this.$t('dw.report.commission.productCode'),
        //   thClass: ['tableMinWidth120'],
        //   formatter: (row, key, item) => {
        //     return this.$options.filters.isEmpty(row)
        //   }
        // },
        {
          key: 'productEnglishName',
          label: this.$t('dw.report.sale.productName'),
          formatter: (row, key, item) => {
            return '<div>' + item.productEnglishName + '</div>' + '<div>' + item.productChineseName + '</div>'
          }
        },
        {
          key: 'customerCode',
          label: this.$t('dw.report.customer.customerCode'),
          thClass: ['tableMinWidth120']
        },
        {
          key: 'customerEnglishName',
          label: this.$t('dw.report.customer.header'),
          formatter: (row, key, item) => {
            return '<div>' + this.$options.filters.isEmpty(item.customerEnglishName) + '</div>' + '<div>' + this.$options.filters.isEmpty(item.customerChineseName) + '</div>'
          }
        },
        {
          key: 'commissionReceivable',
          label: this.$t('adm.companyCommission.commissionReceivable'),
          tdClass: ['text-center', 'tableMinWidth150'],
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'commissionWithheld',
          label: this.$t('adm.companyCommission.commissionWithheld'),
          tdClass: ['text-center', 'tableMinWidth150'],
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
      ],
      reportColumns: [{
        key: 'commissionDifference',
        label: this.$t('dw.report.commission.difference'),
        formatter: (row, key, item) => {
          if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
          return '$ 0'
        }
      }, {
        key: 'status',
        label: this.$t('dw.general.status'),
        formatter: (row, key, item) => {
          return this.generateCommStatusDom(row, this.getTranslated(key, row));
        }
      }],
      adminColumns: [{
        key: 'status',
        label: this.$t('dw.general.status'),
        formatter: (row, key, item) => {
          return this.generateCommStatusDom(row, this.getTranslated(key, row));
        }
      }],
    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: default !important;
}

</style>



// WEBPACK FOOTER //
// src/Adm/CompanyCommission/CompanyCommissionRecord.vue